import React from "react";
import siteConfig from "../../config";

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-5 py-10">
      <div className="mb-[60px]">
        <h2 className="text-[50px] font-bold mb-4">Privacy Policy</h2>
        <p className="text-darkGray mb-4">
          {siteConfig.name} provides its services ("Services") in accordance with the
          following Terms of Service ("Terms"). These Terms are part of the
          overarching Agreement and define the conditions under which you may
          access and use the Services, which include all software, mobile
          applications, websites, and related offerings provided by {siteConfig.name}.
        </p>
        <p className="text-darkGray">
          This Security Policy establishes the principles and guidelines for
          ensuring the confidentiality, integrity, and availability of{' '}
          {siteConfig.name}'s information systems, assets, and data. By using the
          Services, you agree to adhere to this Security Policy, the Privacy
          Policy, and other applicable terms and policies outlined in the
          Agreement. If you do not agree to these terms, you are prohibited from
          accessing or using the Services.
        </p>
      </div>
      <div className="space-y-14">
        <div className="space-y-5">
          <h2 className="text-[36px] font-semibold">1. Information We Collect</h2>
          <div>
            <p className="text-darkGray mb-4">
              We may collect the following types of information:
            </p>
            <ul className="list-disc pl-6 text-darkGray">
              <li>
                Personal Information: Name, email address, phone number, billing
                address, payment information, etc.
              </li>
              <li>
                Non-Personal Information: Browser type, operating system, IP
                address, device information, and usage data.
              </li>
              <li>
                Cookies and Tracking Technologies: To enhance your experience,
                analyze site usage, and improve our services.
              </li>
            </ul>
          </div>
        </div>
        <div className="space-y-5">
          <h2 className="text-[36px] font-semibold">2. How We Use Your Information</h2>
          <p className="text-darkGray">
            We may use the information we collect for purposes such as providing
            and maintaining our services, processing transactions, sending
            administrative communications, improving our website, and complying
            with legal obligations.
          </p>
        </div>
        <div className="space-y-5">
          <h2 className="text-[36px] font-semibold">3. How We Share Your Information</h2>
          <p className="text-darkGray">
            We may share your information with service providers, for legal
            compliance, or during business transfers. We do not sell your
            personal information to third parties.
          </p>
        </div>
        <div className="space-y-5">
          <h2 className="text-[36px] font-semibold">4. Your Rights</h2>
          <p className="text-darkGray">
            Depending on your location, you may have rights to access, correct,
            delete, or restrict processing of your personal information. Contact
            us at info@{siteConfig.name.toLowerCase()}.com to exercise your rights.
          </p>
        </div>
        <div className="space-y-5">
          <h2 className="text-[36px] font-semibold">5. Data Retention</h2>
          <p className="text-darkGray">
            We retain your information only as long as necessary to fulfill the
            purposes outlined in this policy or comply with legal obligations.
          </p>
        </div>
        <div className="space-y-5">
          <h2 className="text-[36px] font-semibold">6. Data Security</h2>
          <p className="text-darkGray">
            We implement measures to protect your information from unauthorized
            access, disclosure, or misuse. However, no method of transmission
            over the internet is 100% secure.
          </p>
        </div>
        <div className="space-y-5">
          <h2 className="text-[36px] font-semibold">7. Changes to This Privacy Policy</h2>
          <p className="text-darkGray">
            We may update this Privacy Policy from time to time. Changes will be
            effective upon posting to this page, and the "Effective Date" will
            be updated accordingly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
